import { map } from "rxjs/operators";
import { GET } from "../../../module/services/fetch";

export const fetchUsersRequest = () =>
  GET(`user/managedUser`).pipe(map((response: any) => response));

export const fetchUsersAccountRequest = (userCode: string) =>
  GET(`user/${userCode}/accounts`).pipe(map((response: any) => response));

export const fetchUsersManagersService = (userCode: string) =>
  GET(`user/${userCode}/secondary-managers`).pipe(
    map((response: any) => response)
  );

export const fetchUsersOusServices = (userCode: string) =>
  GET(`user/${userCode}/secondary-ou`).pipe(map((response: any) => response));

export const fetchUsersEntitlementRequest = (
  userId: any[],
  fetchBusinessRole: boolean = true
) =>
  GET(
    `user/${userId}/entitlements${
      fetchBusinessRole ? "?businessRole=true" : ""
    }`
  ).pipe(map((response: any) => response));
